"use client";

/* BERKAS INI DULUNYA page.jsx DAN SEBUAH SERVER COMPONENT.

   Ia dipecah dua karena satu aturan Next.js yang tidak bisa ditawar:
   `export const metadata` HANYA boleh ada di Server Component,
   sementara useLanguage() memakai React Context yang HANYA hidup di
   Client Component. Satu berkas tidak bisa jadi keduanya - build
   gagal dengan pesan bahwa metadata tidak boleh diekspor dari berkas
   ber-"use client".

   Pembagiannya:
     page.jsx         -> Server Component. Tinggal metadata dan satu
                         baris yang merender berkas ini.
     AboutContent.jsx -> Client Component. Seluruh tampilannya.

   Pola yang sama akan dibutuhkan di SETIAP halaman lain yang
   mengekspor metadata. */

import Image from "next/image";
import Link from "next/link";
/* PATH INI DITULIS UNTUK LOKASI: app/tentang-kami/about/page.jsx

     ../          -> app/tentang-kami
     ../../       -> app
     ../../compo… -> app/components          <- BENAR

   Kalau nanti berkas ini DIPINDAH ke app/(halaman)/tentang-kami/about/,
   tambahkan satu tingkat lagi jadi "../../../components/..." - karena
   (halaman) tetap dihitung sebagai satu folder sungguhan, meskipun
   namanya tidak muncul di URL. Itulah yang bikin jumlah titik-duanya
   gampang meleset. */
import CenterOfExcellence from "../../components/CenterOfExcellence";
import VisiMisi from "../../components/VisiMisi";
import Footer from "../../components/Footer";
import MottoNyaman from "../../components/MottoNyaman";

import { useLanguage } from "../../i18n/LanguageProvider";

/* ============================================================
   HALAMAN ABOUT - /tentang-kami/about

   >>> LETAKKAN DI MANA? <<<
   URL yang Anda buka adalah /tentang-kami/about, dan itu yang
   ditunjuk MENUS di Header.jsx. Dua lokasi menghasilkan URL yang
   sama persis:

     app/(halaman)/tentang-kami/about/page.jsx      <- SARAN SAYA
     app/tentang-kami/about/page.jsx

   Saya sarankan yang pertama, karena folder (halaman) di project Anda
   jelas dibuat untuk mengelompokkan halaman isi. Tanda kurung membuat
   Next.js MENGABAIKAN nama folder itu saat menyusun URL, jadi
   "(halaman)" tidak muncul di alamat.

   ⚠️ VERSI INI SUDAH TIDAK MANDIRI LAGI. Sejak carousel Center of
   Excellence ditambahkan, berkas ini mengimpor satu komponen dari
   app/components/, jadi jumlah "../" pada baris import ITU harus cocok
   dengan lokasi berkas ini. Lihat catatan tepat di atas baris import.

   Fungsi Breadcrumb tetap tertanam di dasar berkas, jadi hanya SATU
   import relatif yang perlu diperhatikan.

   Konsekuensinya: fungsi Breadcrumb ikut ditulis di dasar berkas ini.
   Kalau nanti Anda membuat sub-halaman lain yang juga butuh remah roti
   (Pain Clinic, Business Unit, Gallery), JANGAN menyalin fungsi itu ke
   sana. Pindahkan ke app/components/Breadcrumb.jsx dan impor dari
   kedua halaman - remah roti yang disalin ke banyak berkas adalah cara
   paling umum pemisah, ukuran, atau warnanya jadi berbeda-beda antar
   halaman tanpa ada yang sadar.

   ============================================================
   >>>>>> ISI HALAMAN: APA YANG NYATA DAN APA YANG BELUM <<<<<<

   Dari tangkapan layar yang Anda kirim, HANYA EMPAT hal yang benar-
   benar tertulis tentang RS JMC:

     1. didirikan 15 November 1993
     2. rumah sakit swasta
     3. sudah terakreditasi KARS
     4. unggul dalam Spesialisasi Penyakit Dalam

   Itu saja. Tidak ada sejarah, visi, misi, jumlah dokter, jumlah
   tempat tidur, atau daftar pencapaian.

   Saya TIDAK mengarang sisanya. Halaman About rumah sakit yang berisi
   sejarah karangan adalah masalah yang jauh lebih besar daripada
   halaman About yang pendek: begitu ditayangkan, angka dan tanggal
   karangan itu akan disalin ke proposal, ke media, dan ke dokumen
   akreditasi, dan tidak ada yang ingat dari mana asalnya.

   Blok yang belum ada isinya ditandai GANTI di bawah, dan sebagian
   memang tidak dirender sampai diisi - lihat konstanta TAMPILKAN_*.

   ⚠️ AKREDITASI. Tangkapan layar hanya menyebut "terakreditasi KARS"
   tanpa tingkat. AddressBar.jsx di project Anda menyetel tingkatnya
   "Utama", tapi berkas itu sendiri menandainya PERLU DIVERIFIKASI.
   Di halaman ini saya tulis "KARS" saja tanpa tingkat. Kalau tingkat
   dan masa berlakunya sudah dipastikan, tambahkan di FAKTA.

   ============================================================
   CATATAN TEKNIS

   - pt-[64px] md:pt-[112px] WAJIB ada di pembungkus terluar. Header
     di layout.js posisinya fixed, jadi tanpa padding itu isi halaman
     akan tertutup header. Angkanya sama persis dengan page.jsx:
     64px di ponsel, 112px mulai md.
   - Halaman ini server component (tidak ada "use client"), jadi bisa
     mengekspor metadata dan tidak mengirim JavaScript ke browser.
   - className ditulis satu baris - alasan CRLF yang sama seperti di
     Facility.jsx dan Footer.jsx.
   ============================================================ */

/* Foto gedung. SENGAJA null secara bawaan.

   Kalau diisi path ke berkas yang belum ada, next/image meminta
   berkas itu dan yang muncul kotak rusak - baru ketahuan setelah
   halaman dibuka. Dengan null, tempatnya diisi blok penampung yang
   jelas terbaca "belum diisi".

   Foto di tangkapan layar Anda sekitar 60% langit dan gedungnya
   terhimpit di bawah. Sebelum dipasang, POTONG ULANG ke rasio 4:5
   dengan gedung mengisi sebagian besar bingkai - itu satu-satunya
   perubahan yang paling terasa di halaman ini. */
const FOTO_GEDUNG = "/images/logo rs.png";
/* FOTO_GEDUNG_ALT pindah ke kamus: about.fotoAlt */

/* ⚠️ TEBAKAN. Saya hanya melihat daftar nama berkas di public/images/,
   bukan isinya. Kalau yang muncul bukan gedung, ganti baris di atas
   dengan /images/bg1.png. Tidak ada baris lain yang perlu diubah.

   ============================================================
   KENAPA VERSI SEBELUMNYA TERPOTONG PARAH

   object-cover MEMENUHI bingkai dan membuang sisanya. Foto Anda
   landscape, bingkainya potret 4:5 - selisih rasionya besar, jadi
   yang dibuang juga besar. Yang tersisa cuma satu sudut gedung.

   Menggeser object-position tidak menolong: ia hanya memilih sudut
   mana yang dipakai, bukan mengurangi seberapa banyak yang dibuang.
   Itu kesalahan saya di revisi sebelumnya.

   SEKARANG object-contain: seluruh foto masuk, tidak ada satu piksel
   pun yang dipotong. Konsekuensinya muncul pita kosong di sisi yang
   rasionya tidak pas - dan itulah gunanya bingkai mat di bawah.

   ============================================================
   BINGKAI MENGIKUTI FOTO, BUKAN SEBALIKNYA

   Versi sebelumnya mengunci bingkai ke rasio tetap (4:3) lalu memakai
   object-contain. Foto Anda potret, bingkainya lanskap - jadi muncul
   pita putih lebar di kiri dan kanan.

   Menebak rasio yang pas bukan jalan keluar: begitu fotonya diganti,
   tebakannya salah lagi.

   Sekarang bingkainya TIDAK punya rasio sama sekali. Tingginya
   dihitung browser dari perbandingan asli fotonya, jadi foto potret,
   lanskap, maupun persegi sama-sama mengisi penuh - tanpa pita
   kosong, tanpa terpotong.

   ============================================================
   >>> ISI DUA ANGKA DI BAWAH DENGAN UKURAN ASLI FOTO <<<

   Cara tahu: klik kanan berkasnya di Windows -> Properties ->
   Details -> Dimensions.

   next/image WAJIB tahu perbandingan lebar:tinggi sebelum fotonya
   selesai dimuat, supaya ia bisa memesan ruang yang benar. Kalau
   angkanya meleset, fotonya TETAP tampil utuh dan benar - hanya saja
   isi halaman sempat bergeser sedikit saat foto selesai dimuat.

   Angka di bawah cuma tebakan awal. Ganti dengan yang sebenarnya.
   ============================================================ */
const LEBAR_FOTO = 1000;
const TINGGI_FOTO = 1125;
const TAMPILKAN_SEJARAH = false;

/* Hanya berisi hal yang benar-benar tertulis di sumber Anda. */
const FAKTA = [
  { labelKey: "about.fakta.berdiri", nilai: "1993", catatanKey: "about.fakta.berdiriCatatan" },
  { labelKey: "about.fakta.status", nilaiKey: "about.fakta.statusNilai", catatanKey: "about.fakta.statusCatatan" },
  { labelKey: "about.fakta.akreditasi", nilai: "KARS", catatanKey: "about.fakta.akreditasiCatatan" },
  { labelKey: "about.fakta.faskes", nilai: "Klinik Kirana", catatanKey: "about.fakta.faskesCatatan" },
];

const PETA_TITIK = { lat: -6.2713995, lng: 106.8302645 };

const PETA_CID = "6688073828212235386";

const PETA_URL = `https://maps.google.com/?cid=${PETA_CID}`;

const PETA_RUTE = `https://www.google.com/maps/dir/?api=1&destination=${PETA_TITIK.lat},${PETA_TITIK.lng}`;

const PETA_SEMAT = `https://www.google.com/maps?q=${PETA_TITIK.lat},${PETA_TITIK.lng}&z=17&output=embed`;

const JUDUL_PETA = {
  id: "Peta lokasi RS Jakarta Medical Center",
  en: "Map showing the location of RS Jakarta Medical Center",
};
const TEKS_LOKASI = {
  buka24: { id: "Buka 24 jam", en: "Open 24 hours" },
  rute: { id: "Rute perjalanan", en: "Get directions" },
};

export default function AboutContent() {
  const { t, lang } = useLanguage();

  const tahunBerdiri = 1993;

  return (
    <div className="w-full bg-[var(--c-surface)] pt-[64px] md:pt-[112px]">
      <div className="border-b border-[var(--c-line)] bg-[var(--c-tint)]">
        <div className="mx-auto max-w-[1600px] px-4 py-3 sm:px-6 sm:py-3.5 lg:px-10">
          <Breadcrumb
            items={[
              { label: t("header.nav.home"), href: "/" },
              { label: t("about.eyebrow"), href: "/tentang-kami" },
              { label: t("header.tentang.about") },
            ]}
          />
        </div>
      </div>

      <section className="mx-auto max-w-[1600px] px-4 py-10 sm:px-6 sm:py-14 md:py-20 lg:px-10">
        <div className="grid items-start gap-8 md:gap-12 lg:grid-cols-12 lg:gap-16">

          <div className="lg:col-span-5">
            <FotoGedung t={t} />
          </div>

          <div className="lg:col-span-7">
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--c-brand-mid)] sm:mb-3 sm:text-xs sm:tracking-[0.18em]">
              {t("about.eyebrow")}
            </p>

            {/* text-balance mencegah judul menyisakan satu kata
               sendirian di baris terakhir. */}
            <h1 className="text-balance text-3xl font-bold leading-[1.1] tracking-tight text-[var(--c-ink)] sm:text-4xl md:text-5xl">
              {t("about.judul")}
            </h1>
            <p className="mt-2 text-lg font-semibold text-[var(--c-brand)] sm:text-xl">
              {t("about.singkatan")}
            </p>

            {/* ============================================================
                MOTTO - LENCANA, BUKAN TEKS POLOS

                Ditaruh tepat di bawah nama rumah sakit karena di situlah
                orang membaca "ini siapa" - dan mottonya bagian dari
                jawaban itu.

                Kenapa lencana. Di bawah judul setebal ini, teks biasa
                akan terbaca sebagai anak kalimat dari nama rumah
                sakitnya, seolah "#NyamanSepertiDiRumah" adalah bagian
                dari namanya. Pil berlatar memisahkannya: ini slogan,
                bukan nama.

                Bentuknya SENGAJA sama dengan lencana "Buka 24 jam" di
                blok Lokasi di bawah - dua penanda kecil dengan gaya
                sama terbaca sebagai satu sistem, bukan dua gagasan.

                TANDA PAGAR LEBIH MUDA DARI KATANYA. "#" adalah penanda
                format, bukan bagian dari maknanya. Kalau sama pekatnya,
                mata membacanya lebih dulu dan kalimatnya tersendat.

                sr-only "Tagar" supaya pembaca layar mengucapkannya
                sebagai tagar. Tanpa itu, sebagian pembaca layar
                melewatkan "#" begitu saja dan sebagian lagi mengejanya
                sebagai "pagar" di tengah kalimat.

                w-fit WAJIB. Tanpa itu pil melar selebar kolom dan
                terbaca sebagai bilah, bukan lencana.
                ============================================================ */}
            <p className="mt-3 inline-flex w-fit items-center rounded-full border border-[var(--c-brand-line)] bg-[var(--c-tint)] px-3.5 py-1.5 text-[13px] font-bold tracking-tight text-[var(--c-brand)] sm:mt-3.5 sm:text-sm">
              <span aria-hidden="true" className="mr-px text-[var(--c-brand-mid)]">#</span>
              <span className="sr-only">Tagar </span>
              NyamanSepertiDiRumah
            </p>
            <div className="mt-5 max-w-2xl space-y-4 text-[15px] leading-relaxed text-[var(--c-body)] sm:mt-6 sm:text-base md:text-[17px]">
              <p>
                {t("about.p1")}
              </p>

              <p>
                {t("about.p2")}
              </p>
            </div>

            <div className="mt-7 flex flex-wrap gap-3 sm:mt-8">
              <Link href="/#kontak" className="rounded-lg bg-[var(--c-brand)] px-6 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-[var(--c-panel)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)] sm:text-base">
                {t("about.ctaKontak")}
              </Link>

              <Link href="/jadwal-dokter" className="rounded-lg border-2 border-[var(--c-brand)] bg-transparent px-6 py-3 text-sm font-bold text-[var(--c-brand)] transition-colors duration-200 hover:bg-[var(--c-brand)] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)] sm:text-base">
                {t("about.ctaJadwal")}
              </Link>
            </div>

            {/* ============================================================
                VISI, MISI, MOTTO - ditanam di kolom ini, bukan section
                sendiri.

                Kolom kanan berhenti di tombol, sementara foto gedung di
                kiri jauh lebih tinggi - sisanya ruang kosong yang tidak
                mengerjakan apa pun. Akordeon ini mengisinya, dan tinggi
                kedua kolom jadi seimbang.

                max-w-2xl menyamakan lebarnya dengan paragraf di atas,
                jadi tepi kanannya sejajar - bukan melar sampai tepi
                kolom.

                ⚠️ Visi di dalamnya menyebut target "tahun 2024". Lihat
                peringatan di kepala VisiMisi.jsx sebelum ditayangkan.
                ============================================================ */}
            <div className="max-w-2xl">
              <VisiMisi />
            </div>
          </div>

        </div>
      </section>

      {/* ============================================================
          FAKTA RINGKAS

          Empat angka yang bisa dipindai dalam dua detik. Ini yang
          paling sering dicari orang di halaman About rumah sakit -
          sejak kapan berdiri, statusnya apa, sudah terakreditasi
          belum - dan di tangkapan layar Anda ketiganya terkubur di
          dalam paragraf.

          Latarnya #f1faf5, bukan putih. Bidang ini pendek; warna muda
          membuatnya terbaca sebagai jeda, tanpa menuntut perhatian
          seperti bidang gelap.
          ============================================================ */}
      <section className="border-y border-[var(--c-line)] bg-[var(--c-tint)]">
        <div className="mx-auto max-w-[1600px] px-4 py-8 sm:px-6 sm:py-10 lg:px-10">
          <dl className="grid grid-cols-2 gap-y-6 sm:gap-x-6 md:grid-cols-4 md:gap-x-10">
            {FAKTA.map((item, i) => (
              <div key={item.labelKey} className={i > 0 ? "md:border-l md:border-[var(--c-brand-line)] md:pl-10" : ""}>
                <dt className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--c-brand-mid)]">
                  {t(item.labelKey)}
                </dt>
                <dd className="text-lg font-bold leading-tight text-[var(--c-ink)] sm:text-xl">
                  {item.nilaiKey ? t(item.nilaiKey) : item.nilai}
                </dd>
                {/* slate-600, BUKAN slate-500. Di atas bidang #f1faf5,
                   slate-500 hanya mencapai 4,3:1 - di bawah ambang
                   4,5:1, dan ini teks 12px. slate-600 = 6,85:1. */}
                {item.catatanKey && (
                  <dd className="mt-1 text-[12px] leading-snug text-[var(--c-body)] sm:text-[13px]">
                    {t(item.catatanKey)}
                  </dd>
                )}
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* ============================================================
          CENTER OF EXCELLENCE

          Ditaruh tepat setelah strip Fakta, sesuai permintaan. Urutan
          bacanya jadi: siapa kami -> angka kuncinya -> apa saja yang
          ada di dalamnya.

          Latarnya slate-50, satu-satunya bidang non-putih di halaman
          ini. Itu yang memisahkannya dari blok Fakta di atas (#f1faf5)
          dan blok Lokasi di bawah (putih) tanpa perlu garis tambahan.
          ============================================================ */}
      <CenterOfExcellence />

      <MottoNyaman />

      {/* ============================================================
          SEJARAH - belum dirender

          Setel TAMPILKAN_SEJARAH = true setelah tim RS memberikan
          tonggak-tonggak yang benar beserta tahunnya. Satu-satunya
          tanggal yang saya punya adalah 15 November 1993, dan satu
          tanggal belum cukup untuk membuat lini masa.
          ============================================================ */}
      {TAMPILKAN_SEJARAH && (
        <section className="border-t border-[var(--c-line)] bg-[var(--c-surface)]">
          <div className="mx-auto max-w-[1600px] px-4 py-12 sm:px-6 sm:py-16 lg:px-10">
            <KartuTeks judul="Sejarah" isi={`GANTI: perjalanan RS JMC sejak ${tahunBerdiri}. Minta tonggak dan tahunnya ke tim RS - jangan dikarang.`} />
          </div>
        </section>
      )}

      {/* ============================================================
          LOKASI
          ============================================================ */}
      <section className="mx-auto max-w-[1600px] px-4 py-12 sm:px-6 sm:py-16 md:py-20 lg:px-10">
        {/* Dua kolom di layar lebar, menumpuk sendiri di ponsel.
           Sebelumnya blok ini hanya berisi alamat dan satu tautan -
           kotak selebar layar dengan tiga baris tulisan di dalamnya,
           dan sisanya kosong. Peta mengisi ruang itu sekaligus
           menjawab pertanyaan yang sebenarnya: "di sebelah mana?" */}
        <div className="grid items-stretch gap-0 overflow-hidden rounded-2xl border border-[var(--c-line)] lg:grid-cols-2">

          <div className="flex flex-col justify-center p-6 sm:p-8 md:p-10">
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--c-brand-mid)] sm:text-xs sm:tracking-[0.18em]">
              {t("about.lokasi")}
            </p>

            <h2 className="text-xl font-bold leading-tight text-[var(--c-ink)] sm:text-2xl">
              {t("about.kota")}
            </h2>

            {/* Lencana buka 24 jam. Diambil dari data tempat RS JMC di
               Google Maps, yang mencatatnya "Open 24 hours" - bukan
               karangan. Ditaruh di sini karena itu pertanyaan yang
               paling sering muncul bersamaan dengan "di mana". */}
            <p className="mt-4 inline-flex w-fit items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3.5 py-1.5 text-[13px] font-bold text-emerald-800">
              <span aria-hidden="true" className="h-2 w-2 shrink-0 rounded-full bg-emerald-600" />
              {TEKS_LOKASI.buka24[lang] || TEKS_LOKASI.buka24.id}
            </p>

            <address className="mt-4 max-w-xl text-[15px] not-italic leading-relaxed text-[var(--c-body)] sm:text-base">
              {t("footer.alamat")}
            </address>

            {/* Dua tindakan, bukan satu tautan.

               "Buka di Google Maps" menjawab "di mana ini"; "Rute
               perjalanan" menjawab "bagaimana saya ke sana" - dan
               yang kedua itulah yang sebenarnya dibutuhkan orang yang
               sedang bersiap berangkat. Sebelumnya ia harus membuka
               peta dulu, lalu mencari tombol Directions sendiri. */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a href={PETA_RUTE} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-[10px] bg-[var(--c-brand)] px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[var(--c-brand-strong)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4 shrink-0">
                  <path d="M12 2.5 21.5 12 12 21.5 2.5 12 12 2.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                  <path d="M9.5 14.5v-3a1.5 1.5 0 0 1 1.5-1.5h3.5m0 0-1.6-1.6M14.5 10l-1.6 1.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {TEKS_LOKASI.rute[lang] || TEKS_LOKASI.rute.id}
                <span className="sr-only">, {t("umum.tabBaru")}</span>
              </a>

              <a href={PETA_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 rounded-[10px] border border-[var(--c-brand-line)] bg-[var(--c-surface)] px-5 py-3 text-sm font-bold text-[var(--c-brand)] transition-colors hover:bg-[var(--c-tint)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]">
                {t("about.bukaMaps")}
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4 transition-transform duration-300 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 motion-reduce:transition-none">
                  <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="sr-only">, {t("umum.tabBaru")}</span>
              </a>
            </div>
          </div>

          {/* Peta disemat, bukan tangkapan layar peta.

             loading="lazy": petanya baru diunduh saat pengunjung
             menggulir mendekatinya. Bingkai Google Maps berat - kalau
             diunduh bersamaan dengan halaman, seluruh halaman ikut
             terasa lambat padahal petanya ada di paling bawah.

             Tinggi minimumnya dipatok supaya peta tetap terbaca di
             ponsel; di layar lebar ia meregang mengikuti tinggi kolom
             teks di sebelahnya. */}
          <div className="relative min-h-[300px] w-full bg-[var(--c-line-soft)] sm:min-h-[380px] lg:min-h-[420px]">
            <iframe
              src={PETA_SEMAT}
              title={JUDUL_PETA[lang] || JUDUL_PETA.id}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="absolute inset-0 h-full w-full border-0"
            />
          </div>
        </div>
      </section>

      {/* ============================================================
          FOOTER

          Dipanggil di sini, BUKAN di layout.js - mengikuti pola yang
          sudah dipakai app/page.jsx. Konsekuensinya: setiap halaman
          baru harus mengimpor dan memanggilnya sendiri, dan yang lupa
          akan tampil tanpa footer. Persis yang barusan terjadi di
          halaman ini.

          SARAN: pindahkan <Footer /> ke app/layout.js, tepat sebelum
          penutup body, lalu HAPUS dari app/page.jsx DAN dari berkas ini.
          Header sudah di layout.js - itu sebabnya ia muncul bahkan di
          halaman 404. Footer seharusnya diperlakukan sama.

          Jangan menaruhnya di layout.js tanpa mencabutnya dari kedua
          berkas ini - footernya akan tampil dua kali di halaman depan.
          ============================================================ */}
      <Footer />

    </div>
  );
}

/* ============================================================
   FOTO GEDUNG - BINGKAI MAT

   Polanya diambil dari ClinicSlider.jsx di project ini, yang sudah
   memecahkan masalah yang sama persis untuk poster Klinik Kirana.
   Menyamakan keduanya berarti dua tempat yang menampilkan gambar
   "utuh, jangan dipotong" terlihat sebagai satu keluarga.

   Bingkainya dua lapis, dan sengaja tidak lebih:

   1. MAT (div luar). Bidang #f1faf5 tipis di sekeliling foto,
      memberi jarak antara garis tepi dan gambarnya. Tanpa jarak itu
      garisnya menempel dan terbaca sebagai outline, bukan bingkai.

      Sejak bingkainya mengikuti rasio foto, sudah tidak ada pita
      kosong yang perlu disamarkan - tapi mat tetap dipertahankan
      karena ia juga yang menyamakan tampilan bagian ini dengan kartu
      Klinik Kirana di halaman depan.

   2. GARIS TEPI (ring-inset pada div dalam). Satu garis rambut plum
      10% yang menegaskan batas foto.

      ring-inset, BUKAN border. Border digambar di luar kotak dan pada
      kotak ber-radius sering menyisakan celah rambut di sudut saat
      halaman di-zoom. Ring inset digambar di dalam kotak ber-radius
      yang sama, jadi menempel rapat.

   YANG SENGAJA TIDAK DIPAKAI: bayangan tebal, bingkai ganda, bevel,
   sudut emas. Di situs rumah sakit hiasan semacam itu terbaca seperti
   template lama. Yang membuat bingkai terlihat profesional adalah
   jarak yang konsisten dan satu garis tipis, bukan ornamen.

   Padding mat naik bertahap (12px -> 16px -> 20px) supaya di layar
   kecil ia tidak memakan lebar foto terlalu banyak.

   LATAR DALAM PUTIH, bukan abu-abu. Kalau foto Anda berlatar langit
   terang, pita kosong abu-abu akan terlihat kotor di sebelahnya.
   ============================================================ */

function FotoGedung({ t }) {
  if (!FOTO_GEDUNG) {
    return (
      <div className="flex aspect-[4/5] w-full flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-[var(--c-brand-line)] bg-[var(--c-tint)] p-6 text-center">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-10 w-10 text-[var(--c-brand-mid)]">
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="8.5" cy="10" r="1.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="m4 17 4.5-4.5 3 3L15 12l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <p className="text-sm font-bold text-[var(--c-ink)]">{t("about.fotoKosong")}</p>
        <p className="max-w-xs text-[13px] leading-snug text-[var(--c-body)]">
          {t("about.fotoPetunjuk")}
        </p>
      </div>
    );
  }

  return (
    <figure>
      <div className="rounded-2xl bg-[var(--c-tint)] p-3 ring-1 ring-[var(--c-brand-line)] sm:rounded-[24px] sm:p-4 md:p-5">
        {/* TANPA aspect-*, TANPA fill. Dengan width/height + h-auto,
           tinggi kotak ini mengikuti perbandingan asli fotonya.
           overflow-hidden tetap ada supaya sudut membulatnya rapi. */}
        <div className="relative w-full overflow-hidden rounded-lg bg-[var(--c-surface)] ring-1 ring-inset ring-[var(--c-line)]/10 sm:rounded-xl">
          <Image
            src={FOTO_GEDUNG}
            alt={t("about.fotoAlt")}
            width={LEBAR_FOTO}
            height={TINGGI_FOTO}
            /* Sedikit lebih kecil dari lebar kolomnya karena mat
               memakan padding di kiri-kanan. Angka ini hanya petunjuk
               bagi browser saat memilih ukuran berkas; meleset sedikit
               tidak merusak apa pun. */
            sizes="(min-width: 1024px) 38vw, 92vw"
            priority
            /* h-auto: tinggi ditentukan perbandingan asli foto, bukan
               oleh angka height di atas. w-full: lebar selalu penuh
               mengisi mat. Keduanya harus ada - tanpa h-auto, next/image
               memaksa tinggi persis TINGGI_FOTO dan fotonya jadi gepeng
               kalau angkanya meleset. */
            className="h-auto w-full"
          />
        </div>
      </div>

      {/* Keterangan foto. Dihapus saja kalau tidak perlu - tapi di
         halaman profil, memberi tahu orang bahwa yang mereka lihat
         adalah gedungnya sendiri itu berguna. */}
      <figcaption className="mt-3 text-center text-[13px] leading-snug text-[var(--c-body)] sm:text-sm">
        {t("about.fotoKeterangan")}
      </figcaption>
    </figure>
  );
}

function KartuTeks({ judul, isi }) {
  return (
    <div>
      <h2 className="mb-3 text-xl font-bold leading-tight text-[var(--c-ink)] sm:text-2xl">
        {judul}
      </h2>
      <p className="max-w-2xl text-[15px] leading-relaxed text-[var(--c-body)] sm:text-base">
        {isi}
      </p>
    </div>
  );
}

/* ============================================================
   BREADCRUMB - versi tertanam

   Sama persis dengan app/components/Breadcrumb.jsx. Ditulis di sini
   supaya berkas ini berdiri sendiri.

   AKSESIBILITAS
   - <nav aria-label="Breadcrumb"> supaya pembaca layar bisa melompat
     ke sini sebagai landmark tersendiri.
   - <ol>, bukan <div>: urutannya bermakna.
   - aria-current="page" di item terakhir - itu yang memberi tahu
     pembaca layar "Anda sedang di sini", bukan sekadar cetak tebal.
   - Item terakhir tanpa href. Halaman yang menautkan ke dirinya
     sendiri membingungkan, dan tidak ada yang menekannya.
   - Pemisah ">" digambar sebagai SVG ber-aria-hidden, BUKAN karakter
     teks. Kalau ditulis sebagai teks, pembaca layar akan membacakan
     "lebih besar dari" di antara tiap item.
   ============================================================ */

function Breadcrumb({ items = [] }) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-[13px] sm:text-sm">
      <ol className="flex flex-wrap items-center gap-y-1">
        {items.map((item, i) => {
          const terakhir = i === items.length - 1;

          return (
            <li key={`${item.label}-${i}`} className="flex items-center">
              {/* Pemisah digambar SEBELUM item, kecuali item pertama.
                 Digambar sebagai SVG ber-aria-hidden, bukan karakter
                 teks, supaya tidak ikut dibacakan pembaca layar. */}
              {i > 0 && (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="mx-2 h-3.5 w-3.5 shrink-0 text-[var(--c-faint)] sm:mx-2.5">
                  <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}

              {terakhir || !item.href ? (
                <span aria-current={terakhir ? "page" : undefined} className="font-bold text-[var(--c-brand)]">
                  {item.label}
                </span>
              ) : (
                <Link href={item.href} className="rounded text-[var(--c-muted)] underline-offset-4 transition-colors hover:text-[var(--c-brand)] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
